import React from 'react';
import Link, { LinkProps } from '~/components/Link';
import AppContext from '~/context/AppContext';
interface LinkExternalProps extends LinkProps {
  kioskModeFallback?: React.ReactElement | string;
}
export const LinkExternal: React.FC<LinkExternalProps> = ({
  kioskModeFallback,
  ...linkProps
}: LinkExternalProps): React.ReactElement<LinkExternalProps> | string | null => {
  const appContext = React.useContext(AppContext);
  const {
    isKioskMode
  } = appContext.state;
  if (isKioskMode) {
    return kioskModeFallback || null;
  }
  return <Link isExternal target="_blank" {...linkProps} style={{
    display: 'inline-block'
  }} data-sentry-element="Link" data-sentry-component="LinkExternal" data-sentry-source-file="index.tsx" />;
};
export default LinkExternal;